var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodingSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE49C"
    },
    d: "M472.178,477.38H39.822C17.864,477.38,0,459.515,0,437.557V136.772 c0-9.425,7.641-17.067,17.067-17.067h477.867c9.425,0,17.067,7.641,17.067,17.067v300.785 C512,459.515,494.136,477.38,472.178,477.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD155"
    },
    d: "M494.933,119.706H256V477.38h216.178c21.958,0,39.822-17.864,39.822-39.822V136.772 C512,127.347,504.359,119.706,494.933,119.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8DC3E9"
    },
    d: "M512,153.839H0V74.443C0,52.449,17.829,34.62,39.822,34.62h432.356 C494.171,34.62,512,52.449,512,74.443V153.839z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE49C"
    },
    cx: 71.805,
    cy: 94.231,
    r: 12.836
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE49C"
    },
    cx: 112.959,
    cy: 94.231,
    r: 12.836
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE49C"
    },
    cx: 154.112,
    cy: 94.231,
    r: 12.836
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8DC3E9"
    },
    d: "M141.888,392.487l-65.446-65.447c-6.665-6.665-6.665-17.471,0-24.136l65.446-65.446 c15.946-15.947,40.099,8.173,24.136,24.136l-53.379,53.378l53.379,53.379C181.968,384.296,157.793,408.393,141.888,392.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8DC3E9"
    },
    d: "M196.227,391.681l97.693-169.209c11.272-19.528,40.852-2.489,29.561,17.067l-97.693,169.209 C214.513,428.278,184.939,411.232,196.227,391.681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M512,74.443c0-21.993-17.829-39.822-39.822-39.822H256v119.219h256V74.443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M345.975,368.351l53.38-53.379l-53.38-53.379c-15.945-15.944,8.168-40.104,24.136-24.136 l65.447,65.447c6.661,6.659,6.665,17.472,0,24.136l-65.447,65.447C354.232,408.364,329.853,384.471,345.975,368.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#48AEE2"
    },
    d: "M293.92,222.472L256,288.151v68.266l67.48-116.878C334.777,219.973,305.19,202.95,293.92,222.472z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodingSvgrepoCom);
export default __webpack_public_path__ + "static/media/coding-svgrepo-com.6ca2ebaf5ff7c92f20d90fc26d1b89da.svg";
export { ForwardRef as ReactComponent };